var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9 15.41L5.01 18.72L1.77 18.79C0.8 16.99 0.25 14.93 0.25 12.75C0.25 10.57 0.76 8.64001 1.68 6.89001L4.57 7.42001L5.84 10.29C5.58 11.06 5.43 11.89 5.43 12.75C5.43 13.69 5.6 14.58 5.91 15.41H5.9Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.53 10.37C25.68 11.14 25.75 11.94 25.75 12.75C25.75 13.66 25.65 14.55 25.47 15.41C24.85 18.33 23.23 20.88 20.98 22.69L17.34 22.5L16.83 19.29C18.32 18.42 19.49 17.05 20.1 15.41H13.28V10.37H25.53Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.98 22.69C18.8 24.45 16.02 25.5 13 25.5C8.14002 25.5 3.92002 22.79 1.77002 18.79L5.90002 15.41C6.98002 18.28 9.75002 20.33 13 20.33C14.4 20.33 15.71 19.95 16.83 19.29L20.98 22.69Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.14 2.94L17.01 6.32C15.85 5.59 14.47 5.17 13 5.17C9.67999 5.17 6.84999 7.31 5.82999 10.29L1.67999 6.89C3.79999 2.8 8.06999 0 13 0C16.09 0 18.93 1.1 21.14 2.94Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 25.5,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGLogin);
export default __webpack_public_path__ + "static/media/iconGLogin.ec8adf4b3d83ca9c756560b2a1d8eff2.svg";
export { ForwardRef as ReactComponent };